import React from "react";

const AddModel = ({
  isModalOpen,
  new_model,
  handleChangeModalInput,
  handleAddNewModelToDb,
  closeModal
}) => {
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-50 bg-gray-700 bg-opacity-50 ${
        isModalOpen ? "block" : "hidden"
      }`}
    >
      <div className="bg-white rounded-lg p-8 max-w-md w-full max-h-96 overflow-y-auto shadow-md">
        <button
          onClick={closeModal}
          className="absolute top-2 right-2 text-black text-xl hover:text-gray-700"
        >
          &times;
        </button>

        <h2 className="text-2xl font-sans font-semibold text-center mb-4">
          Add New OEM Model and Specs
        </h2>

        <form className="space-y-4">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Vehicle OEM Name (Manufacturer)
            </label>
            <input
              type="text"
              name="vehicle_oem_name"
              value={new_model.vehicle_oem_name}
              onChange={(e) => handleChangeModalInput(e)}
              className="input"
              placeholder="Vehicle OEM Name"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Vehicle Model Name
            </label>
            <input
              type="text"
              name="vehicle_model_name"
              value={new_model.vehicle_model_name}
              onChange={(e) => handleChangeModalInput(e)}
              className="input"
              placeholder="Vehicle Model Name"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Year of Launch
            </label>
            <input
              type="text"
              name="year_of_launch"
              value={new_model.year_of_launch}
              onChange={(e) => handleChangeModalInput(e)}
              className="input"
              placeholder="Year of Launch"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Vehicle Ex-Showroom Price
            </label>
            <input
              type="text"
              name="vehicle_ex_showroom_price"
              value={new_model.vehicle_ex_showroom_price}
              onChange={(e) => handleChangeModalInput(e)}
              className="input"
              placeholder="Ex-Showroom Price"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Vehicle Available Colors
            </label>
            <input
              type="text"
              name="vehicle_available_colors"
              value={new_model.vehicle_available_colors}
              onChange={(e) => handleChangeModalInput(e)}
              className="input"
              placeholder="Available Colors"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Vehicle Mileage
            </label>
            <input
              type="text"
              name="vehicle_mileage"
              value={new_model.vehicle_mileage}
              onChange={(e) => handleChangeModalInput(e)}
              className="input"
              placeholder="Mileage"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Vehicle Power
            </label>
            <input
              type="text"
              name="vehicle_power"
              value={new_model.vehicle_power}
              onChange={(e) => handleChangeModalInput(e)}
              className="input"
              placeholder="Power"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Vehicle Max Speed
            </label>
            <input
              type="text"
              name="vehicle_max_speed"
              value={new_model.vehicle_max_speed}
              onChange={(e) => handleChangeModalInput(e)}
              className="input"
              placeholder="Max Speed"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Image
            </label>
            <input
              type="text"
              name="image"
              value={new_model.image}
              onChange={(e) => handleChangeModalInput(e)}
              className="input"
              placeholder="Image URL"
            />
          </div>
        </form>

        <div className="modal-footer flex justify-end mt-4">
          <button onClick={closeModal} className="btn mr-2">
            Close
          </button>
          <button onClick={handleAddNewModelToDb} className="btn">
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddModel;
